class NavSignin {

	constructor() {
		this.signinContainerId = "SigninContainer";
		this.signinFontIconId = "SigninFontIconContainer";
		this.signoutLink = "userSignOutLink";
		this.greetingContainerId = "greetingContainerId";
		this.greetingNameId = "greetingNameId";
	}

	getSigninContainerElem () {
		return document.getElementById( this.signinContainerId );
	}

	getSigninFontIconElem () {
	return document.getElementById(this.signinFontIconId);
	}

	getSignoutElem () {
	return document.getElementById(this.signoutLink);
	}

	getGreetingContainer () {
		return document.getElementById(this.greetingContainerId);
	}

	getGreetingNameElem () {
	return document.getElementById(this.greetingNameId);
	}

	doSignin (acct) {
	acct.renderlogin();
	}

	doSignout (acct) {
		if (acct.isLoggedIn()) {
			acct.logout();
		}
	}

	toggleSignedin () {
		var that = this,
		signinContainerElem = that.getSigninContainerElem(),
		signinFontIconElem = that.getSigninFontIconElem();
		if (signinContainerElem && signinFontIconElem) {
			signinFontIconElem.className = "user-icon icon-FS_Icons_signin";
			signinContainerElem.className = "signinContainer site-user-controls logged-in";
		}
	}

	toggleSignedout() {
		var that = this,
		signinContainerElem = that.getSigninContainerElem(),
		signinFontIconElem = that.getSigninFontIconElem();
		if (signinContainerElem && signinFontIconElem) {
			signinFontIconElem.className = "user-icon icon-FS_Icons_signout";
			signinContainerElem.className = "signinContainer site-user-controls logged-out";
		}
	}

	toggleUpdate (acct) {
		acct.isLoggedIn() ? this.toggleSignedin() : this.toggleSignedout();
		if (acct.isLoggedIn()) {
			if (acct.getfirstName() !== "" || acct.getlastName() !=="") {
				this.getGreetingContainer().innerHTML = acct.getfirstNameInitial() + acct.getlastNameInitial();
				this.getGreetingNameElem().innerHTML = acct.getfirstName() + " " +  acct.getlastName();
			}
			else {
				this.getGreetingContainer().innerHTML = "FS";
				this.getGreetingNameElem().innerHTML = "Fox Sports Fan";
			}

		} else {
			this.getGreetingContainer().innerHTML = 'Sign In';
		}
	}

	updatelinks () {
		var logoutlink = document.getElementById('FSDNavAcctLogoutLink'),
			loginlink = document.getElementById('FSDNavAcctLoginLink'),
			href = window.location.href;
		if (loginlink) {
			loginlink.href = '/accounts/login?fu=' + encodeURIComponent(href);
		}
	}

	buildSignedInLinks(acct){
		var that = this,
			host = location.host,
			userProfileEditLink = document.getElementById("userProfileEditLink"),
			userAccountEditLink = document.getElementById("userAccountEditLink"),
			userSignoutLink = that.getSignoutElem();
		userProfileEditLink.href = "/accounts/settings/account-info";
		userAccountEditLink.href = "/accounts/settings/favorites";

		userSignoutLink.addEventListener('click',function() {
			that.doSignout(acct);
		});
	}

	attach (acct) {
		var that = this,
			signinContainerElem = that.getSigninContainerElem(),
			signinLink = that.getSigninFontIconElem();
		if (signinContainerElem) {
			signinLink.addEventListener('click', function() {
				if (acct.isLoggedIn()) {
					return false;
				} else {
					that.doSignin(acct);
				}
			});
			that.buildSignedInLinks(acct);
		}
	}
}
export default NavSignin;







// WEBPACK FOOTER //
// ./assets/components/account/NavSignin.js